import React from "react";
import constant from "../resources/constant";
import { useTranslation } from "react-i18next";

const OrderLabel = ({ status, paid = false }) => {
  const { t } = useTranslation();
  let text = paid && status === 0
    ? t("order_status.paid_cancelled")
    : t(
        `order_status.${
          constant.ORDER_STATUS_TRANSLATION_KEY[status]
        }`
      );
  let text_color = "white";
  let container_color = "lightGrey";

  switch (status) {
    case constant.ORDER_STATUS.AWB_Registered.id:
      // text_color = "#492897";
      // container_color = "#E4DCF3";
      text_color = "#8D027D";
      container_color = "#F8F0F7";
      break;

    case constant.ORDER_STATUS.Out_For_Pickup.id:
      text_color = "#8D027D";
      container_color = "#F8F0F7";
      break;
    case constant.ORDER_STATUS.REACHED_PICKUP.id:
      text_color = "#8D027D";
      container_color = "#F3E5F2";
      break;
    case constant.ORDER_STATUS.Picked_Up.id:
      text_color = "#0F8560";
      container_color = "#CEEDE3";
      break;

    case constant.ORDER_STATUS.In_Transit.id:
      text_color = "#0F8560";
      container_color = "#E4F5F0";
      break;

    case constant.ORDER_STATUS.REACHED_DELIVERY.id:
      text_color = "#0F8560";
      container_color = "#CEEDE3";
      break;
    case constant.ORDER_STATUS.Out_For_Delivery.id:
      text_color = "#0F8560";
      container_color = "#B1DFD1";
      break;

    case constant.ORDER_STATUS.Delivered.id:
      text_color = "#0F8560";
      container_color = "#CEEDE3";
      break;

    case constant.ORDER_STATUS.RTO_OFD.id:
    case constant.ORDER_STATUS.Undelivered.id:
    case constant.ORDER_STATUS.RTO_Initiated.id:
    case constant.ORDER_STATUS.RTO_Delivered.id:
      text_color = "#D75800";
      container_color = "#FFE3CF";
      break;

    case constant.ORDER_STATUS.RTO_Undelivered.id:
      break;

    case constant.ORDER_STATUS.LOST.id:
    case constant.ORDER_STATUS.DAMAGED.id:
      text = t("order_status.lost_damaged");
      text_color = "#BC0000";
      container_color = "#FFEAEC";
      break;

    case constant.ORDER_STATUS.Cancelled.id:
      text_color = "#BC0000";
      container_color = "#FFEAEC";
      break;

    case constant.ORDER_STATUS.DISPOSED.id:
      text_color = "#BC0000";
      container_color = "#FFEAEC";
      break;

    case constant.ORDER_STATUS.Disposed_off.id:
      break;

    case constant.ORDER_STATUS.Pick_Up_Exception.id:
      break;
    case constant.ORDER_STATUS.OPEN.id:
      text_color = "#42526E";
      container_color = "#091E420F";
      break;
    case constant.ORDER_STATUS.CLOSED.id:
      text_color = "#0F8560";
      container_color = "#CEEDE3";
      break;
    case constant.ORDER_STATUS.CANCELLED.id:
      text_color = "#BC0000";
      container_color = "#FFEAEC";
      break;
    default:
      text_color = "#F2C16B";
      container_color = "rgba(252, 240, 219, 0.50)";
      break;
  }

  return (
    <div
      className={`h-6 py-1 px-4 rounded-full flex items-center justify-center`}
      style={{ backgroundColor: container_color }}
    >
      <p
        className={`font-custom text-[10px] font-medium `}
        style={{ color: text_color }}
      >
        {text || t("order_status.pending")}
      </p>
    </div>
  );
};

export default OrderLabel;
